/**
 * LEAD SCORE CALCULATION
 *
 * WARNING: Do not copy+paste this code directly into Zapier – check structure there (esp. `leadData`)
 *
 * A --- decision-makers with large-enough community / point of sales / brands
 * B --- decision-makers with small community
 * C --- all other roles no matter the size
 */

 export const LeadScores = {
  A_LEAD: "A_LEAD",
  B_LEAD: "B_LEAD",
  C_LEAD: "C_LEAD",
};

const topRoles = [
  "1. Vorstand",
  "Vorstandsmitglied",
  "Stadt-/Gemeindebrandmeister:in",
  "Wehrleiter:in",
  "Bürgermeister:in",
];

const midRoles = [
  "Jugendleiter:in",
  "Trainer:in",
];

const decisionMakerRoles = [...topRoles, ...midRoles];

// Not used, in here for documentation purposes only
const lowRoles = [
  "Mitglied",
  "Spieler:in",
  "Elternteil",
]

/**
 * Calculates the score of the given lead – well use a simple decision tree for now.
 *
 * @param {*} leadData the lead data as json
 */
export const calculateLeadScore = (leadData) => {
  const { type, size, role } = leadData;

  /**
   * Attention: fire fighter teams require 100 people less than other clubs
   *
   * We technically don't need to normalize the size, as fire fighters are scored
   * on role only. We might as well keep it for now though in case we want to go back later.
  */
  const normalizedSize = Number(size) + (type === "fire" ? 100 : 0);
  const tooSmall = normalizedSize < 201;

  // All points of sales and fire fighters will go into A directly
  if (type === "pos") {
    return LeadScores.A_LEAD;
  }

  /**
   * All decision-maker roles with large-enough size OR with fire-fighter
   * community will go into A, decision-maker roles with too-small size will
   * go into B, all others (low role) will go into C.
   */
  if (decisionMakerRoles.indexOf(role) > -1) {
    if (type === "fire" || !tooSmall) {
      return LeadScores.A_LEAD;
    }

    return LeadScores.B_LEAD;
  }

  return LeadScores.C_LEAD;
};
